module.exports = __webpack_public_path__ + "img/MES7Indice3_sommaire.ba0977aa.png";